import { IDashboardInformations } from '@interfaces/dashboardInterfaces';
import * as actionTypes from './actionTypes';

export const getMyAccountDashboardEspotPending = () => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_DASHBOARD_ESPOT_PENDING,
    };
};

export const getMyAccountDashboardEspotSuccess = (espot: string) => {
    return {
        espot: espot,
        type: actionTypes.GET_MY_ACCOUNT_DASHBOARD_ESPOT_SUCCESS,
    };
};

export const getMyAccountDashboardEspotError = () => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_DASHBOARD_ESPOT_ERROR,
    };
};

export const getMyAccountReorderTopDashboardEspotPending = () => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_PENDING,
    };
};

export const getMyAccountReorderTopDashboardEspotSuccess = (espotReorderTop: string) => {
    return {
        espotReorderTop: espotReorderTop,
        type: actionTypes.GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_SUCCESS,
    };
};

export const getMyAccountReorderTopDashboardEspotError = () => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_ERROR,
    };
};

export const getMyAccountTopDashboardEspotPending = () => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_PENDING,
    };
};

export const getMyAccountTopDashboardEspotSuccess = (espotTop: string) => {
    return {
        espotTop: espotTop,
        type: actionTypes.GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_SUCCESS,
    };
};

export const getMyAccountTopDashboardEspotError = () => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_ERROR,
    };
};

export const getMyAccountBottomDashboardEspotPending = () => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_PENDING,
    };
};

export const getMyAccountBottomDashboardEspotSuccess = (espotBottom: string) => {
    return {
        espotBottom: espotBottom,
        type: actionTypes.GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_SUCCESS,
    };
};

export const getMyAccountBottomDashboardEspotError = () => {
    return {
        type: actionTypes.GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_ERROR,
    };
};

export const getDashboardInformationsPending = () => {
    return {
        type: actionTypes.GET_DASHBOARD_INFORMATIONS_PENDING,
    };
};

export const getDashboardInformationsSuccess = (dashboardInformations: IDashboardInformations) => {
    return {
        type: actionTypes.GET_DASHBOARD_INFORMATIONS_SUCCESS,
        dashboardInformations: dashboardInformations,
    };
};

export const getDashboardInformationsError = () => {
    return {
        type: actionTypes.GET_DASHBOARD_INFORMATIONS_ERROR,
    };
};
